import { useCallback } from 'react';

import { zendeskZendeskAuthV2 } from '@crossnokaye/typescript-sdk/funcs/zendeskZendeskAuthV2.js';
import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';
import {
  ZendeskAuthV2Request,
  ZendeskAuthV2Response,
} from '@crossnokaye/typescript-sdk/models/operations';
import { useToaster } from '@crossnokaye/ux-common';

import { useAtlasClient } from '@/hooks/use-atlas-client';
import { useCurrentFacility } from '@/hooks/use-current-facility';

export const useZendeskRedirect = () => {
  const { currentFacility, organizationId, agentId } = useCurrentFacility();
  const { addErrorToast } = useToaster();
  const client = useAtlasClient();

  const handleZendeskRedirect = useCallback(
    async (redirectUrl: string) => {
      if (organizationId && agentId && currentFacility?.shortName) {
        try {
          const result = await client<ZendeskAuthV2Request, ZendeskAuthV2Response>({
            atlasFunc: zendeskZendeskAuthV2,
            request: {
              facilityName: currentFacility.shortName,
              returnUrl: redirectUrl,
              orgId: organizationId,
              agentId,
            },
          });

          window.open(result.string, '_blank');
        } catch (error) {
          const sdkError = error as SDKError;
          addErrorToast(
            `Failed to authorize with the help center: ${sdkError.httpMeta.response.statusText}`
          );
          throw error;
        }
      }
    },
    [currentFacility, organizationId, agentId, addErrorToast, client]
  );

  return handleZendeskRedirect;
};
